import React, { useState } from "react";
import Button from "@mui/material/Button";
import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Link } from "react-router-dom";
import { ClickAwayListener, Popover } from "@mui/material";

export default function SimplePopper({ anchorEl, handleAwayClick, text }) {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  return (
    <Popover id={id} open={open} anchorEl={anchorEl}>
      <ClickAwayListener onClickAway={handleAwayClick}>
        <Card sx={{ maxWidth: 345 }}>
          <CardMedia
            component="img"
            height="140"
            image="https://i.pinimg.com/736x/57/a1/15/57a115414f7194bd704f579e52372a7e.jpg"
            alt="pro"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              This is a Pro+ feature!
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {text ||
                "Enjoy Pro+ features and much more with our Pro or Expert plan."}
            </Typography>
          </CardContent>
          <CardActions>
            <Button size="small" component={Link} to="/pricing">
              Upgrade Now
            </Button>
          </CardActions>
        </Card>
      </ClickAwayListener>
    </Popover>
  );
}
